import { theme } from './theme/theme';

/**
 * This is a theme for use with 'styled-components'.
 *
 * This theme has been implemented in terms of our current, Chakra-based theme
 * to keep it aligned with our design requirements, but 'styled-components' is
 * a part of our tech stack which we are trying to phase out in favor of using
 * our Chakra-UI-based design system as implemented by the theme and components
 * in '@frontend/components', so new references to this theme should not be
 * created and old references to it and to 'styled-components' should be removed
 * and replaced with components from '@frontend/components'.
 *
 * @deprecated use our Chakra-based components and theme instead of the
 * 'styled-components' package and this theme.
 */
export const styledComponentsTheme = {
  color: theme.colors,
  font: {
    family: theme.fonts,
    size: {
      A: `font-size: ${theme.fontSizes['3xl']};
          line-height: ${theme.lineHeights['3xl']};`,
      B: `font-size: ${theme.fontSizes['2xl']};
          line-height: ${theme.lineHeights['2xl']};`,
      C: `font-size: ${theme.fontSizes.xl};
          line-height: ${theme.lineHeights.xl};`,
      D: `font-size: ${theme.fontSizes.lg};
          line-height: ${theme.lineHeights.lg};`,
      E: `font-size: ${theme.fontSizes.md};
          line-height: ${theme.lineHeights.md};`,
      F: `font-size: ${theme.fontSizes.sm};
          line-height: ${theme.lineHeights.sm};`,
    },
    weight: theme.fontWeights,
  },
  // Not yet validated.  Do not use outside of component library.
  shadow: {
    popover:
      '0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12)',
    drawer:
      '9px 0 28px 0 rgba(0, 0, 0, 0.05), -6px 0 16px -8px rgba(0, 0, 0, 0.08), -12px 0 48px 16px rgba(0, 0, 0, 0.03)',
  },
  // Not yet validated.  Do not use outside of component library.
  animation: {
    duration: {},
    curve: {},
  },
} as const;
